const Styles = {
  typography: {
    color: "#171B5E",
    marginBottom: 25,
    fontSize: 28,
    fontWeight: 500,
  },

  customTextFieldName: {
    width: "100%",
    marginBottom: 10,
  },

  customTextFieldSecondary: {
    width: "100%",
    marginBottom: 20,
  },

  gridContainerStyle: {
    // marginTop: 8,
    paddingLeft: 28,
  },

  gridPrimary: {
    // marginBottom: 5,
    paddingLeft: 28,
  },

  typographyRadio: {
    fontSize: 14,
    position: "relative",
    color: " #000000",
    fontWeight: 700,
  },

  countryLabel: {
    fontSize: 12,
    fontWeight: 700,
    color: "#8F92A1",
    padding: "5px 15px",
  },

  radioButtonStyle: {
    color: "#FF0000",
    "&.Mui-checked": {
      color: "#FF0000",
    },
  },
  main: {
    display: "flex",
    width: "100%",
    gap: "10px",
  },
  leftContainer: {
    padding: "1rem 2rem 1rem 0",
    width: "65%",
  },
  rightContainer: {
    width: "35%",
  },
  inputContainer: {
    margin: "10px",
  },
  switchContainer: {
    margin: "1rem 0 2rem 0",
  },
  prevText: {
    display: "flex",
    alignItems: "center",
    fontWeight: 500,
    fontSize: 16,
  },
  gridContainer: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gridTemplateRows: "1fr",
    gridRowGap: "1.5rem",
    gridColumnGap: "3.75rem",
  },
  name: {
    gridColumn: "1 / 3",
  },

  buttonStyle: {
    marginTop: 40,
    backgroundColor: "#FF0000",
    borderRadius: 5,
    width: 150,
    height: 52,
    marginLeft: "20%",
    marginBottom: "20%",
  },
};

export default Styles;
